import RedirectToCheckout from '@/components/global/RedirectToCheckout';

export default function Footer({ togglePanel, t, togglePopup, toggleDrawer }) {
  return (
    <footer className='flex justify-between gap-2.5 border-t border-[#e2e8f0] px-3.5 py-3'>
      <button
        onClick={togglePanel}
        className='w-full cursor-pointer appearance-none rounded-[14px] border border-[#272b6f] bg-[#f8fafc] py-3 text-sm font-bold text-[#272b6f] transition-all duration-200 hover:border-[#1b205a] hover:bg-[#1b205a] hover:text-white md:px-[18px]'
      >
        {t('ContinueShopping')}
      </button>

      <RedirectToCheckout
        type={'fromFooter'}
        togglePopup={togglePopup}
        toggleDrawer={toggleDrawer}
      />
    </footer>
  );
}
